import React from 'react';
import { Redirect } from 'react-router-dom'

const Callback : React.FC = () => {
    return <Redirect to="/" />;
}

export default Callback;
